import {useMemo} from "react";
import {Table, Tabs, Typography} from "antd";
import {t} from "i18next";
import {parseHl7} from "./hl7Parser";

// Parse edilmiş HL7 mesajı: segment başına yatay sekme (MSH, PID, OBR ...),
// her sekme alan tablosu. Segment sekmeleri YATAY (üstteki İstek/Rapor buton
// grubundan ayrık). Tablo kendi scroll'una sahip DEĞİL; modal tek scroll eder.
export default function Hl7SegmentViewer({raw}) {
    const parsed = useMemo(() => parseHl7(raw), [raw]);

    if (!parsed.segments.length) {
        return <Typography.Text type={'secondary'}>{t('No message')}</Typography.Text>;
    }

    const columns = [
        { title: t('Field'), dataIndex: 'key', width: 120 },
        {
            title: t('Value'),
            dataIndex: 'value',
            render: (v) => {
                if (!v) return <Typography.Text type={'secondary'}>-</Typography.Text>;
                // Ham değer gösterilir; ^ component parçalaması yapılmaz.
                return <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{v}</div>;
            }
        }
    ];

    return (
        <Tabs tabPosition={'top'} size={'small'}>
            {parsed.segments.map((seg, idx) => (
                <Tabs.TabPane tab={seg.label} key={String(idx)}>
                    <Table
                        size={'small'}
                        rowKey={'key'}
                        pagination={false}
                        dataSource={seg.fields}
                        columns={columns}
                    />
                </Tabs.TabPane>
            ))}
            <Tabs.TabPane tab={t('Raw')} key={'__raw'}>
                <Typography.Paragraph
                    copyable
                    style={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace', fontSize: 12, wordBreak: 'break-word' }}
                >
                    {parsed.raw}
                </Typography.Paragraph>
            </Tabs.TabPane>
        </Tabs>
    );
}
